import "core-js/stable";

import Vue from "vue";
import VueGtm from "vue-gtm";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import dayjs from "@/utils/dayjs";
import "./plugins/element";
import httpauth from "./axios/httpauth";
import httpnoauth from "./axios/httpnoauth";
import httptoken from "./axios/httptoken";
import httpauthhard from "./axios/httpauthhard";
import httpms from "./axios/httpms";
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';

import { initAuth, getAuth0 } from "@/auth/auth0";

Vue.config.productionTip = false;

Vue.prototype.moment = dayjs;
Vue.prototype.$noauth = httpnoauth;
Vue.prototype.$httptoken = httptoken;
Vue.prototype.$http = httpauth;
Vue.prototype.$httphard = httpauthhard;
Vue.prototype.$httpms = httpms;

// dev only
Vue.prototype.DEV = process.env.NODE_ENV === "development";

Vue.use(VueTelInput);

Vue.use(VueGtm, {
  id: "GTM-PV42QSK",
});

async function bootstrap() {
  console.log("🚀 Bootstrapping app...");

  // 1. Init Auth0
  await initAuth();
  const auth0 = getAuth0();

  try {
    /**
     * 2. Handle redirect (after Auth0 login)
     */
    if (window.location.search.includes("code=") && window.location.search.includes("state=")) {
      console.log("🔁 Handling Auth0 redirect...");

      const { appState } = await auth0.handleRedirectCallback();

      // Clean URL
      window.history.replaceState({}, document.title, window.location.pathname);

      /**
       * ✅ Get ACCESS TOKEN (NOT id_token)
       * IMPORTANT: audience must match backend API identifier
       */
      const accessToken = await auth0.getTokenSilently({
        audience: process.env.VUE_AUTH_AUDIENCE,
      });

      console.log("🔐 Access token received (redirect flow)");

      /**
       * ✅ Call backend login
       */
      const response = await fetch(
        `${process.env.VUE_APP_API_URL}/nrl/api/v1/portal/login/token`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Backend login failed");
      }

      const data = await response.json();

      /**
       * ✅ Save backend tokens (StatEdge tokens)
       */
      store.commit("user/LOGIN", data);

      /**
       * ✅ Redirect user (after Vue mounts)
       */
      new Vue({
        router,
        store,
        render: (h) => h(App),
      }).$mount("#app");

      router.replace(appState?.target || "/register");
      return;
    }

    /**
     * 3. Existing session (page refresh case)
     */
    const isAuthenticated = await auth0.isAuthenticated();
    console.log("isAuthenticated:", isAuthenticated);

    if (isAuthenticated && !store.state.user?.authenticated) {
      console.log("♻️ Restoring session...");

      const accessToken = await auth0.getTokenSilently({
        audience: process.env.VUE_AUTH_AUDIENCE,
      });

      console.log("🔐 Access token received (silent)");

      const response = await fetch(
        `${process.env.VUE_APP_API_URL}/nrl/api/v1/portal/login/token`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error("Backend login failed (silent)");
      }

      const data = await response.json();

      store.commit("user/LOGIN", data);
    }
  } catch (err) {
    console.error("❌ Auth error:", err);
  }

  /**
   * 4. Start Vue app (ONLY ONCE)
   */
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
}

/* ---------------- START APP ---------------- */
bootstrap();